import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../../config";
import axios from "../../api/axios";

const cookies = new Cookies();

const useGet = ({
  url,
  initialData,
  onSuccess,
  onError,
  onSettled,
  enabled = true,
  returnEntireResponse = false,
  isIncludeCompanyId = true,
}) => {
  const [paramsObject, setGetListParams] = useState(initialData);
  const company_id = cookies.get(COMPANY_ID);

  const getUsers = async (paramsObject) => {
    let token = cookies.get(TOKEN_NAME);

    const params = {
      ...paramsObject,
      ...(isIncludeCompanyId && { company_id }),
      product_slug: PRODUCT_SLUG,
    };

    const response = await axios.get(`/${url}`, {
      params,
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    if (returnEntireResponse) {
      return response;
    } else {
      return response.data;
    }
  };

  const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
    refetchOnWindowFocus: false,
    enabled: enabled,
    retry: 0,
    onSuccess(data) {
      onSuccess?.(data);
    },
    onError(err) {
      onError?.(err);
    },
    onSettled() {
      onSettled?.();
    },
  });

  return { list, paramsObject, setGetListParams };
};

export default useGet;
